import FeatureFlagModule, { FeatureFlagKeys } from '@modules/FeatureFlagModule';
import { isBookingRetentionEnabled } from './isBookingRetentionEnabled';

/**
 * The single gate for the new Assigned to Me column and manual bookings:
 * its release flag, plus NGJB for calls and booking retention,
 * which manual booking cards need to keep their booking across card switches.
 * When it is off, the Inbox shows today's task list.
 */
export const isNewAssignedToMeUiEnabled = (): boolean =>
  FeatureFlagModule.isEnabled(
    FeatureFlagKeys.featureAssignedToMeManualBookings,
  ) &&
  FeatureFlagModule.isEnabled(
    FeatureFlagKeys.featureEnableAgentInboxForCalls,
  ) &&
  isBookingRetentionEnabled();
